// extracted by mini-css-extract-plugin
module.exports = {"imgUploadModal":"AzJMc","previewImg":"_2Chb0","pictureIcon":"_2XcUR","title":"XOlJU","subTitle":"_1F45k","dragger":"_5KLb","uploadCon":"_2UZcj","uploadBtn":"M3rvV","okBtn":"I9iOP"};